module.exports = __webpack_public_path__ + "static/media/DataSecurityPhoto.ec1f7230.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/DataSecurityPhoto.jpg
// module id = 3751
// module chunks = 0